(function ($) {
  DJ.addBehavior('partnerItemHover', '.js-partners-item-hover', {
    attach: function () {
      const itemsContainer = this;
      const items = itemsContainer.querySelectorAll('.partners-item');


      /**
       * Add mouseover to each partner item.
       * On hover add/remove hover classes from item and item container.
       */
      if (items) {
        const itemsArr = Array.prototype.slice.call(items);

        itemsArr.forEach((item) => {
          item.addEventListener('mouseover', () => {
            item.classList.add('partners-item--this-hover');
            itemsContainer.classList.add('partners-item--hover');
          });

          item.addEventListener('mouseleave', () => {
            item.classList.remove('partners-item--this-hover');
            itemsContainer.classList.remove('partners-item--hover');
          });
        });
      }
    }
  });
})(jQuery);
